import { useGate } from "statsig-react";

export enum Flags {
  MOI_AUTH = "moi_auth",
  PREPAID = "prepaid",
}

export const useFlag = (key: Flags) => {
  const gate = useGate(key);
  return gate.value;
};
